import { labelStyles, responsiveStyles } from '@zapier/common-utils';
import { isolateComponent } from '@zapier/style-encapsulation';
const CSS_CONTAINER_MAX_WIDTH = `${20 + 746 + 20}px`;
const CSS_CONTAINER_DEFAULT_PADDING_TOP = 0;
const CSS_CONTAINER_DEFAULT_PADDING_LEFT = 20;
const CSS_CONTAINER_DEFAULT_PADDING_BOTTOM = 0;
const CSS_CONTAINER_DEFAULT_PADDING_RIGHT = 20;
const Styles = labelStyles(__filename, {
    container: (size, paddingTop, paddingBottom, paddingLeft, paddingRight) => responsiveStyles(size, {
        small: {
            margin: '70px auto',
            paddingTop,
            paddingBottom,
            paddingLeft,
            paddingRight,
        },
        large: {
            margin: '0px auto',
            maxWidth: CSS_CONTAINER_MAX_WIDTH,
            paddingTop,
            paddingBottom,
            paddingLeft,
            paddingRight,
        },
    }),
});
/**
 * A Container to make sure the content doesn't get too wide.
 */
const Container = ({ children, size = 'large', paddingTop = CSS_CONTAINER_DEFAULT_PADDING_TOP, paddingBottom = CSS_CONTAINER_DEFAULT_PADDING_BOTTOM, paddingLeft = CSS_CONTAINER_DEFAULT_PADDING_LEFT, paddingRight = CSS_CONTAINER_DEFAULT_PADDING_RIGHT, }) => {
    return (isolateComponent("div", { css: Styles.container(size, paddingTop, paddingBottom, paddingLeft, paddingRight) }, children));
};
export default Container;
